import { LogoWhiteImage, UserIcon } from "assets";
import classNames from "classnames";
import { links } from "data";
import { useAccordionContext } from "domain/accordion/context";
import { useAuth } from "domain/authentication";
import { MouseEventHandler } from "react";
import { BlankButton, PlainButton } from "shared/components";
import {
  ABOUT_ACCORDION_KEY,
  AboutAccordion,
  Overlay,
  SERVICES_ACCORDION_KEY,
  SUPPORT_ACCORDION_KEY,
  ServicesAccordion,
  SupportAccordion,
} from "./components";
import { RotatableChevron } from "./components/rotatable-chevron";
import styles from "./desktop-header.module.scss";
import { routes } from "router";

export const DesktopHeader = () => {
  const { user, logOut } = useAuth();

  const { getControls, isOpen, closeAll } = useAccordionContext();

  const { closeAllAndSwitch: switchServicesAccordion } = getControls(
    SERVICES_ACCORDION_KEY
  );

  const { closeAllAndSwitch: switchAboutAccordion } =
    getControls(ABOUT_ACCORDION_KEY);

  const { closeAllAndSwitch: switchSupportAccordion } = getControls(
    SUPPORT_ACCORDION_KEY
  );

  const handleOverlayClick: MouseEventHandler<HTMLElement> = (e) => {
    e.stopPropagation();
    closeAll();
  };

  const isOverlayVisible =
    isOpen(SERVICES_ACCORDION_KEY) ||
    isOpen(ABOUT_ACCORDION_KEY) ||
    isOpen(SUPPORT_ACCORDION_KEY);

  const handleSignOut = () => {
    logOut();
  };

  return (
    <div className={styles.container}>
      <header>
        <div className={classNames(styles.content, "container-fluid")}>
          <a href={links.HOMEPAGE}>
            <LogoWhiteImage title="CitySprint header logo" />
          </a>
          <div className="d-flex flex-row">
            <BlankButton onClick={switchServicesAccordion}>
              Services
              <RotatableChevron isOpen={isOpen(SERVICES_ACCORDION_KEY)} />
            </BlankButton>
            <BlankButton onClick={switchAboutAccordion}>
              About us
              <RotatableChevron isOpen={isOpen(ABOUT_ACCORDION_KEY)} />
            </BlankButton>
            <BlankButton onClick={switchSupportAccordion}>
              Support
              <RotatableChevron isOpen={isOpen(SUPPORT_ACCORDION_KEY)} />
            </BlankButton>
            {!user && (
              <BlankButton isLink href={routes.SIGNIN}>
                Sign in
              </BlankButton>
            )}
            {user && (
              <BlankButton onClick={handleSignOut}>Sign out</BlankButton>
            )}
          </div>
          <div className="d-flex flex-row gap-sm">
            <PlainButton isLink href={links.BECOME_A_COURIER}>
              Become a courier
            </PlainButton>
            <PlainButton isLink href={links.SIGN_UP_FOR_AN_ACCOUNT}>
              <div>
                <UserIcon />
              </div>
              <div className="ml-xxs">Sign up for an account</div>
            </PlainButton>
          </div>
        </div>
      </header>
      <div className="relative">
        <Overlay onClick={handleOverlayClick} isVisible={isOverlayVisible} />
        <ServicesAccordion />
        <AboutAccordion />
        <SupportAccordion />
      </div>
    </div>
  );
};
